import {Cart as CartV1, LineItem as LineItemV1} from '@wix/auto_sdk_ecom_current-cart';
import {Cart, V2LineItem} from '@wix/auto_sdk_ecom_current-cart-v-2';

export class CartModel {
  public id?: string;
  public itemsCount?: number;

  constructor(params: CartModel) {
    this.id = params.id;
    this.itemsCount = params.itemsCount;
  }

  public static fromCartV1(cart: CartV1): CartModel {
    return new CartModel({
      id: cart?._id ?? undefined,
      itemsCount: cart?.lineItems ? calculateItemsCountV1(cart?.lineItems) : undefined,
    });
  }

  public static fromCartV2(cart: Cart): CartModel {
    return new CartModel({
      id: cart?._id ?? undefined,
      itemsCount: cart?.lineItems ? calculateItemsCount(cart?.lineItems) : undefined,
    });
  }
}

function calculateItemsCountV1(items: Partial<LineItemV1>[]): number | undefined {
  return items.reduce((total, lineItem) => {
    const {availability, quantity} = lineItem;
    const itemCount =
      availability?.quantityAvailable !== undefined
        ? Math.min(
            availability.quantityAvailable ?? /* istanbul ignore next: todo: missing test */ 0,
            quantity ?? /* istanbul ignore next: todo: missing test */ 0
          )
        : quantity ?? /* istanbul ignore next: todo: missing test */ 0;

    return total + (itemCount || 0);
  }, 0);
}

function calculateItemsCount(items: Partial<V2LineItem>[]): number | undefined {
  return items.reduce((count, lineItem) => {
    const {quantityInfo} = lineItem;
    return count + (quantityInfo?.confirmedQuantity || 0);
  }, 0);
}
